<template>
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M4 18L4 12M4 8L4 3M10 18L10 10M10 6V3M16 18V13M16 9L16 3M2 12H6M8 6L12 6M14 13H18" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
</template>

<script>
export default {};
</script>